<template>
  <div>
    <div class="px-4 sm:px-6 md:px-8 mb-8">
      <div>
        <div class="mb-8">
          <div>
            <h1 class="text-2xl font-semibold text-gray-900">Documents</h1>
          </div>
        </div>
        <div class="rounded-lg bg-white shadow p-4">work in progress</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {}
};
</script>